import { module }from 'stereomodularjs';

const PARAM = {
    UP: `is-scrolling-up`,
    DOWN: `is-scrolling-down`,
}

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let htmlElm = document.querySelector('html')
        let lastScrollPos = 0
        let scrollTop = 0
        let showAfterScroll = false
        let showAfterScrollNav = false

        eventAdd(window, 'scroll.direction', function (event) {
            scrollTop = window.pageYOffset || document.documentElement.scrollTop
            if (scrollTop > lastScrollPos) {
                htmlElm.classList.remove(PARAM.UP)
                htmlElm.classList.add(PARAM.DOWN)
            } else {
                htmlElm.classList.remove(PARAM.DOWN)
                htmlElm.classList.add(PARAM.UP)
            }
            if (lastScrollPos > 75) {
                htmlElm.classList.add('lenis-scrolled')
            } else {
                htmlElm.classList.remove('lenis-scrolled')
            }
            lastScrollPos = scrollTop <= 0 ? 0 : scrollTop // For Mobile or negative scrolling
        });
    }   

    destroy(){
        let htmlElm = document.querySelector('html')
        eventRemove(window, 'scroll.direction')
        htmlElm.classList.remove('lenis-scrolled')
    }
}
